import useI18n from "@/hooks/useI18n";
import { css, cx } from "@styled-system/css";
import { style } from "../styles";

export default function Badge({ save, fromApp }: { save: number | boolean; fromApp: boolean }) {
  const { t } = useI18n();
  const { badge } = style();

  return (
    <p
      className={cx(
        badge,
        css({
          color: "white",
          textAlign: "center",
          fontSize: "0.875rem",
          fontWeight: "600",
          lineHeight: "1rem",
          letterSpacing: "0.13px",
          borderRadius: `0 ${fromApp ? "1.5rem" : "0"} 0 1rem`
        })
      )}
    >
      {`${t("pricing.save")} ${save}%`}
    </p>
  );
}
